<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-toolbar dark :color="'#9e9e9e'">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h1 class="header-tittle" :style="{ color: colorsGeneralSecondary }">
            Cierre de caja (Z)
          </h1>
        </v-toolbar-title>
      </v-toolbar>

      <v-card class="admin-orders">
        <div class="mx-3 pt-4">
          <template v-if="totalRemaining > 0">
            <template
              v-for="(orderTotalByTable, index) in filterdOrdersTotalByTable"
            >
              <v-alert
                type="warning"
                prominent
                class="text-uppercase pt-5"
                :key="`orderTotalByTable_${index}`"
              >
                <v-row align="center">
                  <v-col class="grow"
                    >No se puede hacer el cierre porque en la mesa
                    {{ orderTotalByTable.tableQR }} hay un importe de
                    {{ formatPrice(orderTotalByTable.remaining) }}
                  </v-col>
                </v-row>
              </v-alert>
            </template>
          </template>

          <template v-if="!zClosuresLast">
            <v-alert type="warning" prominent class="text-uppercase pt-5">
              <v-row align="center">
                <v-col class="grow">No hay ninguna cuenta abierta</v-col>
              </v-row>
            </v-alert>
          </template>

          <template v-if="canDoZClousure">
            <v-col cols="12">
              <v-row>
                <v-col cols="6" md="2">
                  <b>APERTURA DE CAJA:</b>
                </v-col>
                <v-col cols="6" md="4">
                  {{ this.dayFormatLLAndTime(zClosuresLast.opened_on) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>CIERRE DE CAJA:</b>
                </v-col>
                <v-col cols="6" md="4">
                  {{ this.dayFormatLLAndTime2(this.today) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>EFECTIVO:</b>
                </v-col>
                <v-col cols="6" md="4">{{ this.formatPrice(totalCash) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>TARJETA:</b>
                </v-col>
                <v-col cols="6" md="4">{{ this.formatPrice(totalCard) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>DATÁFONO:</b>
                </v-col>
                <v-col cols="6" md="4">{{ formatPrice(totalDatafono) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>GOOGLE PAY:</b>
                </v-col>
                <v-col cols="6" md="4">{{ formatPrice(totalGooglePay) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>APPLE PAY:</b>
                </v-col>
                <v-col cols="6" md="4">{{ formatPrice(totalApplePay) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>BIZUM:</b>
                </v-col>
                <v-col cols="6" md="4">{{ formatPrice(totalBizum) }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="2">
                  <b>TOTAL VENTA (I.V.A 10%):</b>
                </v-col>
                <v-col cols="6" md="4"
                  >{{ formatPrice(totalSaleCashCard) }}
                </v-col>
              </v-row>

              <v-row v-if="unPaidOrders && unPaidOrders.length > 0">
                <v-col cols="6" md="2">
                  <b> NOTAS:</b>
                </v-col>
                <v-col cols="6" md="4">
                  <ul style="padding: 0">
                    <li v-for="(order, id) in unPaidOrders" :key="`order${id}`">
                      En la mesa <b>{{ order.table }}</b> no han pagado
                      <b>{{ formatPrice(order.amount) }}</b>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>

            <v-divider></v-divider>

            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <b>RECUENTO DE TODO EL EFFECTIVO QUE HAY EN CAJA</b>
                </v-col>

                <v-col cols="12" md="7">
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(500) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="fiveHundred"
                            v-model="cashCount.fiveHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(200) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="twoHundred"
                            v-model="cashCount.twoHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(100) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="oneHundred"
                            v-model="cashCount.oneHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(50) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="fifty"
                            v-model="cashCount.fifty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(20) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="twenty"
                            v-model="cashCount.twenty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(10) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="ten"
                            v-model="cashCount.ten"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(5) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="five"
                            v-model="cashCount.five"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(2) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="two"
                            v-model="cashCount.two"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(1) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="five"
                            v-model="cashCount.one"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.5) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointFifty"
                            v-model="cashCount.pointFifty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.2) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointTwenty"
                            v-model="cashCount.pointTwenty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.1) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointTen"
                            v-model="cashCount.pointTen"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.05) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroFive"
                            v-model="cashCount.pointZeroFive"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.02) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroTwo"
                            v-model="cashCount.pointZeroTwo"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                          <b>{{ formatPrice(0.01) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroOne"
                            v-model="cashCount.pointZeroOne"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="6" md="2" class="pt-0 pb-0">
                  <b>TOTAL DEL RECUENTO:</b>
                </v-col>
                <v-col cols="6" md="4" class="pt-0 pb-0">
                  {{ formatPrice(totalCashCount) }}
                </v-col>
              </v-row>
            </v-col>

            <!-------------- DESCUADRE ----------------->
            <v-col v-if="hasRoleOwner" cols="12">
              <v-row>
                <v-col cols="6" md="2" class="pt-0 pb-0">
                  <b>DESCUADRE:</b>
                </v-col>
                <v-col cols="6" md="4" class="pt-0 pb-0">
                  {{ formatPrice(cashMismatch) }}
                </v-col>
              </v-row>
            </v-col>

            <v-divider></v-divider>

            <!----------------------  change -------------------------------->
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12">
                  <b>CAMBIO PARA EL SIGUIENTE CIERRE DE CAJA</b>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(50) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changeCountFifty"
                        v-model="changeCount.fifty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(20) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="ctwenty"
                        v-model="changeCount.twenty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(10) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changeCountTen"
                        v-model="changeCount.ten"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(5) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cFive"
                        v-model="changeCount.five"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(2) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changeCountTwo"
                        v-model="changeCount.two"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(1) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cOne"
                        v-model="changeCount.one"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.5) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changepointFifty"
                        v-model="changeCount.pointFifty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.2) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointTwenty"
                        v-model="changeCount.pointTwenty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.1) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changepointTen"
                        v-model="changeCount.pointTen"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.05) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointZeroFive"
                        v-model="changeCount.pointZeroFive"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.02) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointZeroTwo"
                        v-model="changeCount.pointZeroTwo"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-row>
                    <v-col cols="4" class="pt-0 pb-0">
                      <b>{{ formatPrice(0.01) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointZeroOne"
                        v-model="changeCount.pointZeroOne"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="6" md="2" class="pt-0 pb-0">
                  <b>CAMBIO TOTAL:</b>
                </v-col>
                <v-col cols="6" md="4" class="pt-0 pb-0">
                  {{ formatPrice(totalChangeCount) }}
                </v-col>
              </v-row>
            </v-col>
          </template>
        </div>

        <v-card-actions v-if="canDoZClousure">
          <v-btn
            width="100%"
            dark
            class="d-flex justify-center"
            type="success"
            color="green"
            style="font-size: 18px"
            @click="closeBox()"
          >
            <b>Ok</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
  </div>
</template>
<script>
import Loader from "@/components/common/Loader";
import { firestoreTimestamp } from "@/firebaseConfig";
import zClosureMixin from "@/mixins/dashboard/zClosureMixin";
import moment from "moment";
import { ordersCollection, updateOrder } from "@/collections/orders";
import { unPaidOrdersCollection } from "@/collections/unPaidOrders";
import {
  updateOrderTotalByTable,
  ordersTotalByTableCollection
} from "@/collections/ordersTotalByTable";
import { saveZclousure } from "@/collections/zClousures";
export default {
  name: "ZboxClouserDialog",
  components: { Loader },
  props: ["zClosuresLast", "hasRoleOwner"],
  mixins: [zClosureMixin],
  data: () => ({
    dialog: false,
    dialogLoader: false,
    ordersTotalByTable: [],
    openOrders: [],
    cashCount: {
      fiveHundred: 0,
      twoHundred: 0,
      oneHundred: 0,
      fifty: 0,
      twenty: 0,
      ten: 0,
      five: 0,
      two: 0,
      one: 0,
      pointFifty: 0,
      pointTwenty: 0,
      pointTen: 0,
      pointZeroFive: 0,
      pointZeroTwo: 0,
      pointZeroOne: 0
    },
    changeCount: {
      fifty: 0,
      twenty: 0,
      ten: 0,
      five: 0,
      two: 0,
      one: 0,
      pointFifty: 0,
      pointTwenty: 0,
      pointTen: 0,
      pointZeroFive: 0,
      pointZeroTwo: 0,
      pointZeroOne: 0
    }
  }),
  firestore() {
    return {
      // eslint-disable-next-line no-undef
      ordersTotalByTable: ordersTotalByTableCollection,
      openOrders: ordersCollection.where("isOpen", "==", true)
    };
  },
  computed: {
    canDoZClousure() {
      return this.zClosuresLast && this.totalRemaining === 0;
    },
    unPaidOrders() {
      let unPaidOrdersResult = [];
      if (this.zClosuresLast.id) {
        try {
          // eslint-disable-next-line vue/no-async-in-computed-properties
          unPaidOrdersCollection
            .where("zcloser_id", "==", this.zClosuresLast.id)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(doc => {
                unPaidOrdersResult.push({ id: doc.id, ...doc.data() });
              });
            });
        } catch (error) {
          this.setlogError(
            "unPaid_orders_collection",
            "Obtained error message in unPaidOrders()",
            error.stack,
            this.$options.name
          );
        }
      }
      return unPaidOrdersResult;
    },
    today() {
      return moment().format();
    },
    filterdOrdersTotalByTable() {
      return this.ordersTotalByTable.filter(
        item =>
          item.remaining > 0 &&
          (item.tableQR !== "todas" || item.tableQR !== "NO QR")
      );
    },
    totalRemaining() {
      return this.filterdOrdersTotalByTable.reduce((a, b) => {
        return Number(a) + Number(b.remaining);
      }, 0);
    },
    totalCashCount() {
      return (
        Number(this.cashCount.fiveHundred) * 500 +
        Number(this.cashCount.twoHundred) * 200 +
        Number(this.cashCount.oneHundred) * 100 +
        Number(this.cashCount.fifty) * 50 +
        Number(this.cashCount.twenty) * 20 +
        Number(this.cashCount.ten) * 10 +
        Number(this.cashCount.five) * 5 +
        Number(this.cashCount.two) * 2 +
        Number(this.cashCount.one) +
        Number(this.cashCount.pointFifty) * 0.5 +
        Number(this.cashCount.pointTwenty) * 0.2 +
        Number(this.cashCount.pointTen) * 0.1 +
        Number(this.cashCount.pointZeroFive) * 0.05 +
        Number(this.cashCount.pointZeroTwo) * 0.02 +
        Number(this.cashCount.pointZeroOne) * 0.01
      );
    },
    totalChangeCount() {
      return (
        Number(this.changeCount.fifty) * 50 +
        Number(this.changeCount.twenty) * 20 +
        Number(this.changeCount.ten) * 10 +
        Number(this.changeCount.five) * 5 +
        Number(this.changeCount.two) * 2 +
        Number(this.changeCount.one) +
        Number(this.changeCount.pointFifty) * 0.5 +
        Number(this.changeCount.pointTwenty) * 0.2 +
        Number(this.changeCount.pointTen) * 0.1 +
        Number(this.changeCount.pointZeroFive) * 0.05 +
        Number(this.changeCount.pointZeroTwo) * 0.02 +
        Number(this.changeCount.pointZeroOne) * 0.01
      );
    },
    cashMismatch() {
      return (
        Number(this.totalCash) -
        (Number(this.totalCashCount) - Number(this.totalChangeCountAccumulated))
      );
    },
    totalChangeCountAccumulated() {
      return this.zClosuresLast.total_change_count_accumulated
        ? this.zClosuresLast.total_change_count_accumulated
        : this.totalChangeCount;
    },
    totalCash() {
      return this.zClosuresLast.total_invoiced_in_cash
        ? this.zClosuresLast.total_invoiced_in_cash
        : 0;
    },
    totalCard() {
      return this.zClosuresLast.total_invoiced_on_credit_card
        ? this.zClosuresLast.total_invoiced_on_credit_card
        : 0;
    },
    totalGooglePay() {
      return this.zClosuresLast.total_invoiced_in_google_pay
        ? this.zClosuresLast.total_invoiced_in_google_pay
        : 0;
    },
    totalApplePay() {
      return this.zClosuresLast.total_invoiced_in_apple_pay
        ? this.zClosuresLast.total_invoiced_in_apple_pay
        : 0;
    },
    totalBizum() {
      return this.zClosuresLast.total_invoiced_in_bizum
        ? this.zClosuresLast.total_invoiced_in_bizum
        : 0;
    },
    totalDatafono() {
      return this.zClosuresLast.total_invoiced_in_datafono
        ? this.zClosuresLast.total_invoiced_in_datafono
        : 0;
    },
    totalSaleCashCard() {
      return (
        this.totalCash +
        this.totalCard +
        this.totalDatafono +
        this.totalGooglePay +
        this.totalApplePay +
        this.totalBizum
      );
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    async closeBox() {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        let zClosureLast = this.zClosuresLast;
        let zClosureLastId = zClosureLast?.id;
        let closed_on = moment().toDate();
        let opened_on = moment(
          zClosureLast?.opened_on?.seconds * 1000
        ).toDate();

        let orderSummary = await this.buildOrderSummary(opened_on, closed_on);
        let paymentSummary = await this.buildPaymentSummary(
          opened_on,
          closed_on,
          zClosureLastId
        );
        let data = {
          closed_on: closed_on,
          opened_on: opened_on,
          total_invoiced_in_cash: paymentSummary.total_invoiced_in_cash,
          total_invoiced_in_datafono: paymentSummary.total_invoiced_in_datafono,
          total_invoiced_on_credit_card:
            paymentSummary.total_invoiced_on_credit_card,
          total_invoiced_in_apple_pay:
            paymentSummary.total_invoiced_in_apple_pay,
          total_invoiced_in_google_pay:
            paymentSummary.total_invoiced_in_google_pay,
          total_invoiced_in_bizum: paymentSummary.total_invoiced_in_bizum,
          z_closure_id: parseInt(zClosureLastId),
          cash_count: this.cashCount,
          total_cash_count: this.totalCashCount,
          change_count: this.changeCount,
          total_change_count: this.totalChangeCount,
          total_change_count_accumulated:
            paymentSummary.total_change_count_accumulated,
          cash_mismatch: this.cashMismatch,
          totalOrders: orderSummary.orders.totalOrders,
          foodCount: orderSummary.orders.foodCount,
          drinkCount: orderSummary.orders.drinkCount,
          dessertCount: orderSummary.orders.dessertCount,
          foodAmount: orderSummary.orders.foodAmount,
          drinkAmount: orderSummary.orders.drinkAmount,
          dessertAmount: orderSummary.orders.dessertAmount,
          totalOrdersAmount: orderSummary.orders.totalOrdersAmount,
          totalAmount: paymentSummary.totalAmount,
          products: orderSummary.products,
          customers: orderSummary.customers,
          cntCash: paymentSummary.cntCash,
          cntCreditCard: paymentSummary.cntCreditCard,
          cntApplePay: paymentSummary.cntApplePay,
          cntGpay: paymentSummary.cntGpay,
          cntDatafono: paymentSummary.cntDatafono,
          cntBizum: paymentSummary.cntBizum
        };
        await saveZclousure(zClosureLastId, data);

        this.$emit("updateZclosures");

        let ordersZero = {
          remaining: 0,
          time: time
        };

        this.dialog = false;

        this.ordersTotalByTable.forEach(element => {
          updateOrderTotalByTable(element.id, ordersZero).catch(error => {
            this.setlogError(
              "update_order_total_by_table",
              "Obtained error message in closeBox()",
              error.stack,
              this.$options.name
            );
          });
        });

        let now = moment().format();

        this.openOrders.forEach(item => {
          if (item.metadata) {
            // eslint-disable-next-line no-unused-vars
            for (const [quantity, metadata] of Object.entries(item.metadata)) {
              item.metadata[quantity].isPaid = true;
            }
          }
          item.isOpen = false;
          item.orderClosedAt = now;
          updateOrder(item.id, item).catch(error => {
            this.setlogError(
              "update_order",
              "Obtained error message in closeBox()",
              error.stack,
              this.$options.name
            );
          });
        });
      } catch (error) {
        this.setlogError(
          "save_zclousure",
          "Obtained error message in closeBox()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>
